import { render, staticRenderFns } from "./ProwebInfoBanner.vue?vue&type=template&id=ec1eb768&scoped=true&"
import script from "./ProwebInfoBanner.vue?vue&type=script&lang=js&"
export * from "./ProwebInfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./ProwebInfoBanner.vue?vue&type=style&index=0&id=ec1eb768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1eb768",
  null
  
)

export default component.exports